import RequestError, { Response } from './RequestError';

export default class RequestFailedError extends RequestError {
  constructor(
    response: Response,
    public code?: number,
    public message: string = 'Request error',
  ) {
    super(response, `${code}: ${message}`);
    Object.setPrototypeOf(this, new.target.prototype);
    this.code = code;
    this.name = 'RequestFailedError';
  }
}
